import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Navbar,
  Nav,
  Card,
  Badge,
  Image,
  Offcanvas,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Navigate, useNavigate } from "react-router-dom";
import {
  FaWhatsapp,
  FaFilePdf,
  FaShippingFast,
  FaPlane,
  FaShip,
  FaRocket,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaUserPlus,
  FaShoppingCart,
  FaWarehouse,
  FaHome,
  FaGift,
  FaCheckCircle,
  FaExclamationTriangle,
  FaDollarSign,
  FaHeadset,
  FaInstagram,
  FaFacebook,
  FaTiktok,
  FaShareAlt,
  FaClock,
  FaBox,
  FaMapMarkedAlt,
  FaTag,
  FaCreditCard,
  FaTruck,
  FaBoxOpen,
  FaLock,
  FaSmile,
  FaCalendarAlt,
  FaArrowUp,
  FaArrowDown,
  FaChevronRight,
  FaTimes,
  FaPlayCircle,
  FaPlay,
  FaBoxes,
  FaPallet,
  FaPlaneDeparture,
} from "react-icons/fa";

import { Player } from "@lottiefiles/react-lottie-player";
import { motion } from "framer-motion";

import inicio from "../../assets/inicio.png";
import logoMbox from "../../assets/MBOX-LOGO-BLANCO.png";
import video1 from "../../assets/Video1.mp4";
import video2 from "../../assets/Video2.mp4";
import video3 from "../../assets/video3.mp4";
import video4 from "../../assets/video4.mp4";

import mboxitoMexico from "../../assets/mboxitoMexico.png";
import mboxitoEEUU from "../../assets/mboxitoEEUU.png";

import deliveryAnim from "../../assets/Animation - 1748224957909.json";
import mascota from "../../assets/MBOXITO_MASCOTA.png";
import trackingAnimation from "../../assets/Animation - 1747624631532.json";
import boxAnimation from "../../assets/Animation - 1747626198371.json";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";


const ParcelsSection = () => {
  return (
    <section id='encomiendas' className='py-5 position-relative'>
          <Container>
            {/* Mascota animada */}
            <motion.div
              className='d-none d-lg-block position-absolute'
              style={{ right: "20px", top: "50px", zIndex: 1 }}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              whileHover={{ scale: 1.1 }}
            >
              <img
                src={mascota}
                alt='Mascota MBOX'
                className='img-fluid'
                style={{ maxWidth: "150px" }}
              />
            </motion.div>

            <Row className='justify-content-center mb-5'>
              <Col lg={8} className='text-center'>
                <motion.h2
                  className='display-5 fw-bold mb-3'
                  style={{ color: "#182848" }}
                  initial={{ opacity: 0, y: -20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  Envió de encomiendas y documentos a Estados Unidos
                </motion.h2>

                <motion.p
                  className='lead text-muted mx-auto'
                  style={{ maxWidth: 600 }}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.2, duration: 0.5 }}
                >
                  En MBOX, te ayudamos a enviar tus encomiendas y documentos de
                  manera rápida y segura a Estados Unidos. Si necesitas enviar
                  regalos, paquetes personales o documentos importantes, con
                  MBOX podés hacerlo fácilmente y con seguimiento completo.
                </motion.p>

                {/* Animación Lottie */}
                <motion.div
                  className='mt-4'
                  style={{ height: "150px" }}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.4 }}
                >
                  <Player
                    autoplay
                    loop
                    src={deliveryAnim}
                    style={{ height: "100%", width: "100%" }}
                  />
                </motion.div>
              </Col>
            </Row>

            <Row className='g-4 align-items-stretch'>
              {" "}
              {/* Añadido align-items-stretch */}
              {/* Qué puedes enviar */}
              <Col md={6}>
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  className='h-100' /* Añadido h-100 */
                >
                  <Card
                    className='border-0 shadow-lg h-100 d-flex flex-column' /* Añadido h-100 y flex-column */
                    style={{
                      borderRadius: "12px",
                      transition: "transform 0.3s ease",
                      borderTop: "4px solid #4b6cb7",
                      transform: "translateY(-5px)",
                      opacity: 0.75, // transparencia ligera
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "translateY(-15px)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "translateY(-5px)")
                    }
                  >
                    <Card.Body className='p-0 d-flex flex-column h-100'>
                      {" "}
                      {/* Añadido flex-column y h-100 */}
                      <div className='p-4 pb-0 flex-grow-1'>
                        {" "}
                        {/* Añadido flex-grow-1 */}
                        <motion.div
                          className='d-flex align-items-center mb-4'
                          whileHover={{ x: 5 }}
                        >
                          <motion.div
                            className='bg-light-primary text-primary rounded-circle d-inline-flex align-items-center justify-content-center p-3 me-3'
                            whileHover={{ rotate: 15 }}
                            style={{
                              backgroundColor: "rgba(75, 108, 183, 0.1)",
                            }}
                          >
                            <FaShippingFast size={28} color='#4b6cb7' />
                          </motion.div>
                          <Card.Title
                            className='fw-bold mb-0'
                            style={{ color: "#182848" }}
                          >
                            ¿Qué puedes enviar?
                          </Card.Title>
                        </motion.div>
                        <ul className='list-unstyled mb-4'>
                          <motion.li
                            className='py-2 d-flex align-items-start'
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.3 }}
                          >
                            <FaCheckCircle className='text-primary mt-1 me-2' />
                            <span>
                              <strong>Documentos importantes:</strong> Títulos,
                              contratos, pasaporte, DNI, partida de nacimiento,
                              cartas legales u otra documentación oficial que
                              necesite llegar a EE. UU. con urgencia y
                              seguridad.
                            </span>
                          </motion.li>

                          <motion.li
                            className='py-2 d-flex align-items-start'
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.4 }}
                          >
                            <FaCheckCircle className='text-primary mt-1 me-2' />
                            <span>
                              <strong>Encomiendas personales:</strong> Productos
                              como frijoles, arroz, miel, café, medicina natural
                              (con registro sanitario), ropa, accesorios y
                              artículos de uso cotidiano. Perfecto para quienes
                              desean enviar un pedacito de casa a sus seres
                              queridos en el extranjero.
                            </span>
                          </motion.li>
                        </ul>
                      </div>
                      <div
                        className='text-white p-3 text-center rounded-bottom'
                        style={{
                          borderBottomLeftRadius: "12px",
                          borderBottomRightRadius: "12px",
                          background:
                            "linear-gradient(90deg, #1CB5E0 0%, #000851 100%)",
                        }}
                      >
                        <span className='fw-bold'>
                          Envíos seguros y confiables
                        </span>
                      </div>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
              {/* Tarifas y precios */}
              <Col md={6}>
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.3 }}
                  className='h-100' /* Añadido h-100 */
                >
                  <Card
                    className='border-0 shadow-lg h-100 d-flex flex-column' /* Añadido h-100 y flex-column */
                    style={{
                      borderRadius: "12px",
                      transition: "transform 0.3s ease",
                      borderTop: "4px solid #4b6cb7",
                      transform: "translateY(-5px)",
                      opacity: 0.85, // transparencia ligera
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "translateY(-15px)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "translateY(-5px)")
                    }
                  >
                    <Card.Body className='p-0 d-flex flex-column h-100'>
                      {" "}
                      {/* Añadido flex-column y h-100 */}
                      <div className='p-4 pb-0 flex-grow-1'>
                        {" "}
                        {/* Añadido flex-grow-1 */}
                        <motion.div
                          className='d-flex align-items-center mb-4'
                          whileHover={{ x: 5 }}
                        >
                          <motion.div
                            className='bg-light-primary text-primary rounded-circle d-inline-flex align-items-center justify-content-center p-3 me-3'
                            whileHover={{ rotate: 15 }}
                            style={{
                              backgroundColor: "rgba(75, 108, 183, 0.1)",
                            }}
                          >
                            <FaDollarSign size={28} color='#4b6cb7' />
                          </motion.div>
                          <Card.Title
                            className='fw-bold mb-0'
                            style={{ color: "#182848" }}
                          >
                            Tarifas y precios
                          </Card.Title>
                        </motion.div>
                        <div className='mb-4'>
                          <motion.div
                            className='d-flex align-items-center mb-3'
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.3 }}
                          >
                            <FaRocket className='text-primary me-2' />
                            <h5 className='text-primary fw-bold mb-0'>
                              Servicio Priority
                            </h5>
                          </motion.div>

                          <ul className='list-unstyled mb-4'>
                            <motion.li
                              className='py-2 d-flex align-items-start'
                              initial={{ opacity: 0, x: -20 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{ delay: 0.4 }}
                            >
                              <FaCheckCircle className='text-primary mt-1 me-2' />
                              <span>
                                0 a 1 libra: <strong>L 1,600</strong>
                              </span>
                            </motion.li>
                            <motion.li
                              className='py-2 d-flex align-items-start'
                              initial={{ opacity: 0, x: -20 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{ delay: 0.5 }}
                            >
                              <FaCheckCircle className='text-primary mt-1 me-2' />
                              <span>
                                Cada libra adicional: <strong>L 500</strong>
                              </span>
                            </motion.li>
                            <motion.li
                              className='py-2 d-flex align-items-start'
                              initial={{ opacity: 0, x: -20 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{ delay: 0.6 }}
                            >
                              <FaClock className='text-primary mt-1 me-2' />
                              <span>
                                Tiempo estimado:{" "}
                                <strong>1 a 2 días hábiles</strong>
                              </span>
                            </motion.li>
                          </ul>
                        </div>
                        <div>
                          <motion.div
                            className='d-flex align-items-center mb-3'
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ delay: 0.7 }}
                          >
                            <FaTruck className='text-primary me-2' />
                            <h5 className='text-primary fw-bold mb-0'>
                              Servicio Economy
                            </h5>
                          </motion.div>

                          <ul className='list-unstyled'>
                            <motion.li
                              className='py-2 d-flex align-items-start'
                              initial={{ opacity: 0, x: -20 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{ delay: 0.8 }}
                            >
                              <FaCheckCircle className='text-primary mt-1 me-2' />
                              <span>
                                0 a 1 libra: <strong>L 1,500</strong>
                              </span>
                            </motion.li>
                            <motion.li
                              className='py-2 d-flex align-items-start'
                              initial={{ opacity: 0, x: -20 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{ delay: 0.9 }}
                            >
                              <FaCheckCircle className='text-primary mt-1 me-2' />
                              <span>
                                Libra adicional: <strong>L 400</strong>
                              </span>
                            </motion.li>
                            <motion.li
                              className='py-2 d-flex align-items-start'
                              initial={{ opacity: 0, x: -20 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{ delay: 1.0 }}
                            >
                              <FaClock className='text-primary mt-1 me-2' />
                              <span>
                                Tiempo estimado:{" "}
                                <strong>4 a 6 días hábiles</strong>
                              </span>
                            </motion.li>
                            <motion.li
                              className='py-2 d-flex align-items-start'
                              initial={{ opacity: 0, x: -20 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{ delay: 1.1 }}
                            >
                              <FaExclamationTriangle className='text-warning mt-1 me-2' />
                              <span>
                                No recomendado para productos perecederos
                              </span>
                            </motion.li>
                          </ul>
                        </div>
                      </div>
                      {/* Franja inferior destacada */}
                      <div
                        className='text-white p-3 text-center rounded-bottom'
                        style={{
                          borderBottomLeftRadius: "12px",
                          borderBottomRightRadius: "12px",
                          background:
                            "linear-gradient(90deg, #f7971e 0%, #ffd200 100%)",
                        }}
                      >
                        <span className='fw-bold'>
                          Las mejores tarifas del mercado
                        </span>
                      </div>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            </Row>
          </Container>
        </section>
  );
};

export default ParcelsSection;
